import { useSyncExternalStore } from 'react';
import {
  getChatUnreadCount,
  getChatUnreadVersion,
  subscribeChatUnread,
} from './unread-store';

function getSnapshot(): number {
  // Version is read so React re-renders when the store bumps even if count is unchanged.
  void getChatUnreadVersion();
  return getChatUnreadCount();
}

export function useChatUnreadCount(): number {
  return useSyncExternalStore(subscribeChatUnread, getSnapshot, () => 0);
}
